/** Lakás-azonosító → elemek, a forrás (API) sorrendjében. */
export type FlatIndex<T> = ReadonlyMap<number, readonly T[]>;

export const EMPTY_FLAT_INDEX: FlatIndex<never> = new Map();

/**
 * Lakásra csoportosít, a bemenet sorrendjét megtartva — a belépőkód-választás a sorrendben
 * első egyezőt veszi, ezért itt rendezni tilos. Lakás nélküli elem kimarad.
 */
export function indexByFlat<T>(items: readonly T[], flatIdOf: (item: T) => number | null | undefined): FlatIndex<T> {
  const index = new Map<number, T[]>();
  for (const item of items) {
    const flatId = flatIdOf(item);
    if (flatId !== null && flatId !== undefined) {
      index.set(flatId, [...(index.get(flatId) ?? []), item]);
    }
  }
  return index;
}

export const itemsForFlat = <T>(index: FlatIndex<T>, flatId: number): readonly T[] => index.get(flatId) ?? [];
